import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { MenuOpenButton, NavigationDrawer } from "./navigation-drawer";
import { TopMenuContainer, TopMenuLogoLink, TopMenuMain } from "./style";
import { Logo, Plan } from "..";
import { urlsPages } from "../urls/urls-pages";
import { UserAvatar } from "../user-avatar/user-avatar";

interface TopMenuProps {
    children?: React.ReactNode;
    avatarEnabled?: boolean;
}

export const TopMenu: React.FC<TopMenuProps> = ({ children, avatarEnabled = true }) => {
    const [drawerOpen, setDrawerOpen] = useState(false);
    const { pathname } = useLocation();

    useEffect(() => {
        setDrawerOpen(false);
    }, [pathname]);

    return (
        <>
            <TopMenuContainer>
                <MenuOpenButton menuOpen={drawerOpen} onOpen={() => setDrawerOpen(true)} />
                <TopMenuMain>
                    <TopMenuLogoLink href={urlsPages.drills}>
                        <Logo />
                    </TopMenuLogoLink>
                    <Plan />
                </TopMenuMain>
                {children}
                {avatarEnabled && <UserAvatar />}
            </TopMenuContainer>
            <NavigationDrawer open={drawerOpen} onClose={() => setDrawerOpen(false)} />
        </>
    );
};
